import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { updateRoute } from '../../redux/CartReducer';
import Header from '../header/Header';
import './InfoPage.scss';
import './ResponsiveInfoPage.scss';
import axios from 'axios';
import Loader from '../Loader';
import JsonData from '../../json';

const devEnv = process.env.NODE_ENV !== "production";
const { REACT_APP_DEV_URL, REACT_APP_PROD_URL } = process.env;

let url = "http://localhost:5002";

const InfoPage = () => {
    const location = useLocation();
    const navigate = useNavigate();

    let dispatch = useDispatch();

    let [defaultImage, setDefaultImage] = useState("");
    let [sectionImage, setSectionImage] = useState([]);
    let [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        // //ajax call axios.get(`${devEnv ? REACT_APP_DEV_URL : REACT_APP_PROD_URL}/first-section`)
            let result = JsonData["first-section"].find(x => x.id == location.state.id);
                setSectionImage(result);
                setDefaultImage(result.image);
                setLoading(false);
    }, []);

    let chnageImage = (url) => {
        setDefaultImage(url);
    };

    let buyNow = () => {
        addToCart();
        navigate('/cart');
    };

    let addToCart = () => {
        // with redux
        dispatch(updateRoute({
            sectionImage: sectionImage,
            defaultImage: defaultImage,
        }));

        // with api
        // axios.post(url + '/cart-list', { ...sectionImage, defaultImage: defaultImage })
        //     .then(res => {
        //         // console.log(res)
        //     })
    };

    return (
        <>
            {!loading ?
                <div id="infopage_background">
                    <Header />

                    <div className="infopage_flex">

                        <div className="infopage_div1">
                            {sectionImage.about?.images.map((data, i) => (
                                <img src={data} key={i} alt="image" onClick={() => { chnageImage(data) }} />
                            ))}
                        </div>

                        <div className="infopage_div2">
                            <img src={defaultImage} alt="image" />
                        </div>

                        <div className="infopage_div3">
                            <span>{sectionImage.about?.desc}</span>
                            <hr style={{ marginTop: '2rem', marginBottom: '2rem' }} />

                            <span style={{ color: 'green' }}>In Stock</span>
                            <div className="infopage_div3_price">
                                <div>M.R.P.:<span>&#8377; {sectionImage.about?.originalprice}</span></div>
                                <div>Price:<span>&#8377; {sectionImage.about?.afterdiscountprice}</span></div>
                                <div>You Save:<span>&#8377;{(parseInt(sectionImage.about?.originalprice) - parseInt(sectionImage.about?.afterdiscountprice))} ({Math.floor((parseInt(sectionImage.about?.originalprice) - parseInt(sectionImage.about?.afterdiscountprice)) / (parseInt(sectionImage.about?.originalprice)) * 100)}%)</span></div>
                            </div>

                            <hr style={{ marginTop: '2rem', marginBottom: '2rem' }} />
                            <div className="infopage_div3_status">
                                <span>FREE delivery <b>Wednesday</b>, <span className='hyperlink'>Details</span></span>
                                <br /><br />
                                <span><span className='hyperlink'>Or fastest delivery </span><b>Tuesday</b>, Order within 5 hrs 25 mins. <span className='hyperlink'>Details</span></span>
                            </div>
                            <button className="infopage_div3_button" style={{ marginBottom: '6rem' }} onClick={addToCart}>Add To Cart</button>
                        </div>

                        <div className="infopage_div4">
                            <h1>&#8377; {sectionImage.about?.afterdiscountprice}</h1>
                            <span>FREE delivery <b>Wednesday</b>, <span className='hyperlink'>Details</span></span>

                            <span><span className='hyperlink'>Or fastest delivery </span><b>Tuesday</b>, Order within 5 hrs 25 mins. <span className='hyperlink'>Details</span></span>
                            <hr style={{ marginTop: '2rem', marginBottom: '2rem' }} />

                            <button className="infopage_div4_button1" onClick={addToCart}>Add to Cart</button>
                            <button className="infopage_div4_button2" onClick={buyNow}>Buy Now</button>
                        </div>
                    </div>
                </div> :
                <Loader/>}
        </>
    )
};

export default InfoPage;